<div class="dashboard-container">
  <ng-container *ngIf="hideGraph">
    <div class="heading-container">
      <span class="heading">
        Choose Your Report Option
        <mat-icon
          class="info"
          matTooltip="Instructions: Select a report (Heat Plan, Bunker Report, or Final Report) to print. Click on Customized View to proceed to the next page."
          >info</mat-icon
        >
      </span>
    </div>
    <div class="button-container">
      <button
        class="btn btn-light hover-button-fetch fetchData"
        (click)="fetchNewData()"
      >
        <mat-icon>keyboard_backspace</mat-icon>
        <span class="name">Fetch Another Vessel</span>
      </button>
    </div>
    
    <div class="vessel-details-container">
      <div class="vessel-info">
        <div class="vessel-detail">
          <span class="vessel-label">Vessel Name:</span>
          <span class="vessel-value">{{ vesselName }}</span>
        </div>
        <div class="vessel-detail">
          <span class="vessel-label">IMO:</span>
          <span class="vessel-value">{{ vesselImo }}</span>
        </div>
      </div>
    </div>

    <h2 class="graph-title"></h2>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5 borderbgv">
          <div class="row">
            <!-- Card 1 -->
            <div class="col-md-6 col-sm-12">
              <div class="heat-plan-container">
                <div
                  class="heat-plan"
                  (mouseenter)="showImage()"
                  (mouseleave)="hideImage()"
                  (click)="printReport('heat_plan')"
                >
                  <div class="content-container heatIcon">
                    <div class="icon-container">
                      <i class="fas fa-thermometer-half"></i>
                      <span class="card-name">Heat Plan</span>
                    </div>
                  </div>
                  <img
                    class="heat-plan-image"
                    src="../../../assets/images/Heatplanimage.PNG"
                    alt="Heat Plan"
                  />
                </div>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col-md-6 col-sm-12">
              <div class="heat-plan-container">
                <div
                  class="heat-plan"
                  (mouseenter)="showImage()"
                  (mouseleave)="hideImage()"
                  (click)="printReport('bunker_forecast')"
                >
                  <div class="content-container">
                    <div class="icon-container">
                      <i class="fas fa-gas-pump"></i>
                      <span class="card-name">Bunker Report</span>
                    </div>
                  </div>
                  <img
                    class="heat-plan-image"
                    src="../../../assets/images/Bunker.PNG"
                    alt="Bunker Report"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Card 3 -->
            <div class="col-md-6 col-sm-12">
              <div class="heat-plan-container">
                <div
                  class="heat-plan"
                  (mouseenter)="showImage()"
                  (mouseleave)="hideImage()"
                  (click)="printReport('final_report')"
                >
                  <div class="content-container">
                    <div class="icon-container">
                      <i class="fas fa-file-alt"></i>

                      <span class="card-name">Final Report</span>
                    </div>
                  </div>
                  <img
                    class="heat-plan-image"
                    src="../../../assets/images/finalimage.PNG"
                    alt="Final Report"
                  />
                </div>
              </div>
            </div>
            <!-- Card 4 -->
            <div class="col-md-6 col-sm-12">
              <div class="heat-plan-container">
                <div
                  class="heat-plan"
                  (mouseenter)="showImage()"
                  (mouseleave)="hideImage()"
                  (click)="printReport('avg_temp_forecast')"
                >
                  <div class="content-container">
                    <div class="icon-container">
                      <i class="fas fa-tachometer-alt"></i>
                      <span class="card-name">Average Cargo Temp</span>
                    </div>
                  </div>
                  <img
                    class="heat-plan-image"
                    src="../../../assets/images/avg.PNG"
                    alt="Average Cargo Temp"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <div class="col-md-6 borderbgv">
          <div  class="col-md-1"></div>
          <!-- Card 5 -->

          <div class="heat-plan-container customized-card">
            <div
              class="heat-plan customized"
              (mouseenter)="showImage()"
              (mouseleave)="hideImage()"
              (click)="nextGraphData()"
            >
              <div class="content-container">
                <div class="icon-container">
                  <i class="fas fa-chart-column"></i>
                  <span class="card-name">Customized View and Print</span>
                </div>
              </div>
              <img
                class="heat-plan-image customized-image"
                src="../../../assets/images/graphimagess.jpeg"
                alt="Customized View and Print"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
